import CustomEvent from 'custom-event';
import Layer from './layer';
import { mergeDeep } from '../../services/helper.service';

export default class AbstractObject {

  constructor(options, defaultOptions = {}) {
    this.defaultOptions = defaultOptions;
    this.options = options;

    this.object = new Layer();

    this.name = this.options.name;
  }

  set options(value) {
    this._options = mergeDeep(this.defaultOptions, value);
  }

  get options() {
    return this._options;
  }

  set name(value) {
    this.object.mesh.name = value;
  }

  get name() {
    return `${this.options.name}${this.options.type ? `_${this.options.type}` : ''}`;
  }

  get position() {
    return this.object.mesh.position;
  }

  get rotation() {
    return this.object.mesh.rotation;
  }

  get size() {
    return {
      width: null,
      height: null,
      depth: null
    };
  }

  get htmlLayer() {
    return this.object.htmlLayer;
  }

  get mesh() {
    return this.object.mesh;
  }

  init() {
    throw new Error('Abstract method!');
  }

  update(options) {
    this.clear();

    this.options = mergeDeep(this.options, options);

    this.init();
  }

  clear() {
    this.object.clear();
  }

  render(camera, renderer) {
    this.htmlLayer.render(camera, renderer);
  }

  onOptionUpdate(callback) {
    if (!callback) throw new Error('Can\'t find callback function');

    this.htmlLayer.domElement.addEventListener('options-update', (e) => {
      callback(e.detail.options, e.detail.ignoreObjectUpdate, e.detail.resetCalculateResults);
    });
  }

  dispatchOptionUpdate(options, ignoreObjectUpdate, resetCalculateResults) {
    const event = new CustomEvent('options-update', {
      detail: { options, ignoreObjectUpdate, resetCalculateResults }
    });
    this.htmlLayer.domElement.dispatchEvent(event);
  }

}



// WEBPACK FOOTER //
// ./src/object-view/misc/object.js